var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isWearableProduct)?_c('div',{staticClass:"pr-WearableProduct"},[_c('h3',{staticClass:"pr-ProductOptions_SectionTitle"},[_vm._v("\n    Size\n  ")]),_vm._v(" "),_c('div',{staticClass:"pr-WearableProduct_Note"},[_vm._v("\n    This will be specified on the order process screen.\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }